import { EntityAdapter, Update } from "@reduxjs/toolkit";
import GenericSliceWrapper, { RemovedOutputEntities } from "./genericSliceWrapper";
import { adaptOutputAdapter, adaptRoiRuleAdapter, AdaptSliceState, aeTitleRuleAdapter, backendValidationErrorAdapter, customizationBaseAdapter, dicomAttributeRuleAdapter, dicomRuleAdapter, modelAdapter, outputMetadataAdapter } from "../../adapt/adaptSlice";
import { AdaptCustomizationEntities, AdaptCustomizationOutput, AdaptRoiRule } from "../../adapt/adapt-types";

export class AdaptSliceWrapper extends GenericSliceWrapper<AdaptSliceState> {

    outputAdapter: EntityAdapter<AdaptCustomizationOutput, string>;
    adaptRoiRuleAdapter: EntityAdapter<AdaptRoiRule, string>;


    constructor() {
        super(
            modelAdapter,
            customizationBaseAdapter,
            outputMetadataAdapter,
            aeTitleRuleAdapter,
            dicomRuleAdapter,
            dicomAttributeRuleAdapter,
            backendValidationErrorAdapter,
        )
        this.outputAdapter = adaptOutputAdapter;
        this.adaptRoiRuleAdapter = adaptRoiRuleAdapter;
    }

    protected findOutput(state: AdaptSliceState, outputId: string): AdaptCustomizationOutput | undefined {
        return state.adaptOutputs.entities[outputId];
    }

    protected updateOutput(state: AdaptSliceState, update: Update<AdaptCustomizationOutput, string>): void {
        this.outputAdapter.updateOne(state.adaptOutputs, update);
    }

    /** Collects which store entities need to be removed and updated when a customization output is removed. */
    public collectCustomizationOutputEntitiesFromStoreForRemoval(state: AdaptSliceState, output: AdaptCustomizationOutput, customizationBaseId: string): RemovedOutputEntities {

        const metadataIdsToBeRemoved: string[] = [];
        const adaptRoiRuleIdsToBeRemoved: string[] = [];



        metadataIdsToBeRemoved.push(...output.metadata);
        if (output.roiSelection) { adaptRoiRuleIdsToBeRemoved.push(...output.roiSelection.roiRules); }

        return {
            metadataIdsToBeRemoved,
            adaptRoiRuleIdsToBeRemoved,
            allRemovedIds: [
                ...metadataIdsToBeRemoved,
                ...adaptRoiRuleIdsToBeRemoved,
            ],
        };
    };



    protected removeOutputRelatedItems(state: AdaptSliceState, outputIds: string[], items: RemovedOutputEntities) {
        const { metadataIdsToBeRemoved, adaptRoiRuleIdsToBeRemoved, } = items;

        if (metadataIdsToBeRemoved) { this.outputMetadataAdapter.removeMany(state.outputMetadata, metadataIdsToBeRemoved); }
        if (adaptRoiRuleIdsToBeRemoved) { this.adaptRoiRuleAdapter.removeMany(state.adaptRoiRules, adaptRoiRuleIdsToBeRemoved); }


        this.outputAdapter.removeMany(state.adaptOutputs, outputIds);
    }

    protected setOutputRelatedItemsAsModified(state: AdaptSliceState, entitiesToUpdate: Partial<AdaptCustomizationEntities>) {

        const adaptRoiRuleIds = entitiesToUpdate.adaptRoiRules?.map(id => id.id);
        const customizationOutputsIds = entitiesToUpdate.adaptOutputs?.map(id => id.id);

        if (adaptRoiRuleIds && adaptRoiRuleIds.length > 0) {
            this.adaptRoiRuleAdapter.updateMany(
                state.adaptRoiRules,
                adaptRoiRuleIds.map(adaptRoiRuleId => ({ id: adaptRoiRuleId, changes: { isModified: true } }))
            );
        }

        if (customizationOutputsIds && customizationOutputsIds.length > 0) {
            this.outputAdapter.updateMany(
                state.adaptOutputs,
                customizationOutputsIds.map(customizationOutputId => ({ id: customizationOutputId, changes: { isModified: true } }))
            );
        }
    }

}
